import React, { useEffect, useState } from 'react'
import Context from './Context'
import { checkJwt, incrementConnection } from './services'
import LoadingPage from '../common/LoadingPage'
import WelcomePage from './pages/WelcomePage'
import SimulationPage from './pages/simulation/SimulationPage'
import FaqPage from './pages/faq/FaqPage'
import ContactPage from './pages/ContactPage'
import RecordPage from './pages/record/RecordPage'
import { Redirect, Route, Switch } from 'react-router'
import DeclarationPage from './pages/declaration/DeclarationPage'
import ContactInformationPage from './pages/ContactInformationPage'
import NotificationPage from './pages/welcome/NotificationPage'
import ApproveConsentPage from './pages/welcome/ApproveConsentPage'

function PrivateApp() {
  const [ratpId, setRatpId] = useState(null)
  const isAuthenticated = () => localStorage.getItem('jwt-token')

  useEffect(() => {
    if (!isAuthenticated()) {
      window.location.assign('/auth/login?redirectPath=' + window.location.pathname)
    }
  })

  useEffect(() => {
    if (!ratpId) {
      checkJwt().then(resp => {
        resp && setRatpId(resp)
      })
    }
    incrementConnection()
  }, [])

  if(!ratpId) {
    return <LoadingPage/>
  }

  return <Context>
    <Switch>
      <Route path="/" exact={ true } component={ WelcomePage }/>
      <Route path="/simulation" render={ () => <SimulationPage simulationOnly={true}/> } />
      <Route path="/deposit" component={ SimulationPage } />
      <Route path="/faq" component={ FaqPage }/>
      <Route path="/contact" component={ ContactPage }/>
      <Route path="/contactInformation" component={ ContactInformationPage }/>
      <Route path="/record/:id" component={ RecordPage } />
      <Route path="/declaration/:id" component={ DeclarationPage } />
      <Route path="/notifications/:id" component={ NotificationPage } />
      <Route path="/consent" component={ ApproveConsentPage } />
      <Route path="*" render={ () => <Redirect to={'/error/404'}/> } />
    </Switch>
  </Context>
}

export default PrivateApp
